import { Injectable } from '@angular/core';
import { DataService } from 'src/app/shared/session';

@Injectable({
  providedIn: 'root'
})
export class AccesoSubmoduloService {

  constructor(private dataService: DataService) { }

  private saveAccesoSubmoduloUrl: string = 'accesoSubmodulo/save';

  guardarAccesoSubmodulo(idAplicacion: number, idNivelAcceso: number, idEntidad: number, idRol: number, idAccess: number): any {
    let parameters: string;
    parameters = JSON.stringify({
      idAplicacion: idAplicacion,
      idNivelAcceso: idNivelAcceso,
      idEntidad: idEntidad,
      idRol: idRol,
      idAccess: idAccess,
    });
    this.dataService.set(this.saveAccesoSubmoduloUrl);
    return this.dataService.execPostJson(parameters);
  }
}